export function getUserLevel(user) {
  if (!user || typeof user !== 'object') return null;

  const perms = Array.isArray(user?.permissions) ? user.permissions : [];
  // ⚠️ permissions는 role(레벨)과 별개일 수 있어 여기서 레벨로 승격시키지 않는다.

  const directKeys = [
    'level',
    'role',
    'role_level',
    'roleLevel',
    'auth_level',
    'authLevel',
    'user_level',
    'userLevel',
    'member_level',
    'memberLevel',
  ];

  for (const k of directKeys) {
    const v = user?.[k];
    if (v == null) continue;
    const n = Number.parseInt(String(v).trim(), 10);
    if (Number.isFinite(n)) return n;
  }

  for (const raw of perms) {
    const s = String(raw ?? '').trim();
    if (!s) continue;
    // ex) "level:2", "role=1", "LEVEL_2", "ROLE-3", "L2"
    const m1 = s.match(/(?:^|[^a-z0-9])(level|role)\s*[:=_-]?\s*(\d+)(?:$|[^a-z0-9])/i);
    if (m1 && m1[2]) {
      const n = Number.parseInt(m1[2], 10);
      if (Number.isFinite(n)) return n;
    }
    const m2 = s.match(/^(?:LEVEL|ROLE)[\s:_-]?(\d+)$/i);
    if (m2 && m2[1]) {
      const n = Number.parseInt(m2[1], 10);
      if (Number.isFinite(n)) return n;
    }
    const m3 = s.match(/^L(\d+)$/i);
    if (m3 && m3[1]) {
      const n = Number.parseInt(m3[1], 10);
      if (Number.isFinite(n)) return n;
    }
  }

  return null;
}


